import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Alert,
  Stack,
} from '@mui/material';
import { verifyStaffCredentials } from '../services/api';

const KioskStaffAuthDialog = ({
  open,
  onClose,
  onSuccess,
  title = 'Acceso al terminal',
  description = 'Ingresa las credenciales de un administrador o encargado de sucursal.',
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setEmail('');
      setPassword('');
      setError('');
      setLoading(false);
    }
  }, [open]);

  const handleSubmit = async () => {
    setError('');
    setLoading(true);
    try {
      await verifyStaffCredentials(email.trim(), password);
      onSuccess();
    } catch (err) {
      setError(
        err.response?.data?.message ||
          'Credenciales inválidas o sin permiso. Solo administrador o encargado.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {description}
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Stack spacing={2}>
          <TextField
            label="Correo"
            type="email"
            fullWidth
            autoFocus
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Contraseña"
            type="password"
            fullWidth
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || !email.trim() || !password}
        >
          {loading ? 'Verificando…' : 'Continuar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KioskStaffAuthDialog;
